import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import Layout from '../views/Layout'

export const constantRouterMap = [
  { path: "/", component: () => import("@/views/Login"), hidden: true },
  { path: "/appLogin", component: () => import("@/views/AppLogin"), hidden: true },
  // {path: '/login', component: () => import('@/views/Login'), hidden: true},
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "",
    component: Layout,
    meta: { title: "个人中心", icon: "person" },
    children: [
      {
        path: "profile",
        name: "profile",
        component: () => import("@/views/Profile"),
      },
    ],
    hidden: true,
  },
  {
    path: "",
    component: Layout,
    meta: { title: "感知中心", icon: "dashboard" },
    children: [
      {
        path: "main",
        name: "main",
        component: (resolve) => require(["@/views/Main"], resolve),
      },
    ],
  },
];
export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    name: "station",
    redirect: "/station",
    meta: { title: "基站管理", icon: "devices_other" },
    children: [
      {
        path: "station",
        name: "stationIndex",
        component: (resolve) => require(["../views/station/index"], resolve),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "deviceGird",
    redirect: "/deviceGrid",
    meta: { title: "设备台账", icon: "devices_other" },
    children: [
      {
        path: "deviceGrid",
        name: "DeviceGridIndex",
        component: (resolve) =>
          require(["../views/device/DeviceGrid"], resolve),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "deviceBrain",
    redirect: "/deviceBrain",
    meta: { title: "设备详情", icon: "my_location" },
    children: [
      {
        path: "deviceBrain",
        name: "DeviceBrainIndex",
        component: (resolve) =>
          require(["../views/device/DeviceBrain"], resolve),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "alarm",
    redirect: "/alarmList",
    meta: { title: "风险预警", icon: "warning" },
    children: [
      {
        path: "alarmList",
        name: "AlarmList",
        component: (resolve) => require(["../views/alarm/AlarmList"], resolve),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "dept",
    redirect: "/dept/list",
    meta: { title: "组织机构", icon: "groups" },
    children: [
      {
        path: "dept/list",
        name: "DeptList",
        component: (resolve) => require(["../views/system/dept"], resolve),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "user",
    redirect: "/user/list",
    meta: { title: "用户管理", icon: "supervisor_account" },
    children: [
      {
        path: "user/list",
        name: "UserList",
        component: (resolve) => require(["../views/user/UserList"], resolve),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "role",
    redirect: "/system/role",
    meta: { title: "角色管理", icon: "manage_accounts" },
    children: [
      {
        path: "system/role",
        name: "RoleIndex",
        component: (resolve) => require(["../views/system/Role"], resolve),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "menu",
    redirect: "/system/menu",
    meta: { title: "菜单管理", icon: "widgets" },
    children: [
      {
        path: "system/menu",
        name: "MenuIndex",
        component: (resolve) => require(["../views/system/Menu"], resolve),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "alarmSetting",
    meta: { title: "预警设置", icon: "admin_panel_settings" },
    children: [
      {
        path: "alarmSetting",
        name: "alarmSetting",
        component: (resolve) => require(["../views/setting/alarm"], resolve),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "ota",
    redirect: "/otaVersion",
    meta: { title: "OTA版本", icon: "widgets" },
    children: [
      {
        path: "otaVersion",
        name: "OtaIndex",
        component: (resolve) => require(["../views/ota/index"], resolve),
      },
    ],
  },
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/routers/index.js